import { useState } from "react";
import "../style/Diensleistung.css";
import { Container, Image, Button, Row, Col } from "react-bootstrap";
import headlinePic from "./images/Diestleistung_Headlinepic.png";
import serviceIllustration from "./images/Dienstleistung_Diag.png";
import meetingPic from "./images/Meeting.jpg";
import referenzenFooter from "./images/Referenzen.png";

function Diensleistung(props) {
    const baseColor = "#8c1030"; // initial red tone
    const activeColor = "#111D4B"; // focus color
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const timelineSteps = [
        {
            title: "Vorauswahl und Rekrutierung",
            description:
                "Sie teilen uns Ihre genauen Personalanforderungen mit und wir stellen Ihnen innerhalb kurzer Zeit (2 bis 4 Wochen) passende Kandidaten für Ihre Einrichtung vor.",
        },
        {
            title: "Persönliches Gespräch und Einstellung",
            description:
                "Ein persönliches Gespräch wird geplant. Anschließend wird der Arbeitsvertrag abgeschlossen und die weitere Planung gestartet.",
        },
        {
            title: "Anerkennungsverfahren",
            description: "Das Berufsanerkennungsverfahren wird eingeleitet und begleitet.",
        },
        {
            title: "Sprachqualifikationen und Visum",
            description:
                "Wir vertiefen die Sprachqualifikationen und organisieren bei Bedarf Fachsprachenkurs und Visum.",
        },
        {
            title: "Anreise und Onboarding",
            description:
                "Die Einreise wird geplant und unterstützt; wir begleiten die Kandidaten bei ihren ersten Schritten in Deutschland.",
        },
        {
            title: "Anerkennung und Integration",
            description:
                "Wir betreuen die Berufsanerkennung und unterstützen bei der Integration – flexibel und eng an Ihrer Seite.",
        },
    ];

    return (
        <>
           <div className="medway-hero dienst-hero">
                <Image src={headlinePic} alt="Medway Team" fluid className="medway-hero__image" />
                <div className="medway-hero__overlay" />
                <div className="medway-hero__content dienst-hero__content">
                    <h1 className="medway-hero__title" style={{ fontWeight: 300 }}>
                        Fachkräftevermittlung
                    </h1>
                    <p className="medway-hero__subtitle" style={{ fontWeight: 300, marginBottom: 0 }}>
                        Hochqualifizierte medizinische Fachkräfte aus Tunesien für deutsche Gesundheitseinrichtungen
                    </p>
                    <div>
                        <Button
                            variant="outline-light"
                            size="lg"
                            style={{
                                padding: "12px 28px",
                                borderRadius: "999px",
                                fontWeight: 600,
                                fontSize: "1rem",
                                backgroundColor: "rgba(255,255,255,0.08)",
                                borderWidth: "2px",
                            }}
                        >
                            Mehr zu unseren Leistungen
                        </Button>
                    </div>
                </div>
            </div>
           <Container className="my-4">
                <div className="medway-card medway-section--center">
                    <div
                        style={{
                            textTransform: "uppercase",
                            fontSize: "0.9rem",
                            letterSpacing: "0.16em",
                            color: "#9c0f2e",
                            fontWeight: 700,
                            marginBottom: "12px",
                        }}
                    >
                        Dienstleistungen von Medway
                    </div>
                    <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", margin: "0 auto 24px" }}>
                        <h2
                            style={{
                                color: "#0f4b78",
                                fontSize: "2rem",
                                fontWeight: 500,
                                marginBottom: "12px",
                            }}
                        >
                            Expertise im Gesundheitswesen
                        </h2>
                        <div
                            style={{
                                width: "100%",
                                height: "3px",
                                backgroundColor: "#9c0f2e",
                            }}
                        />
                    </div>
                    <p
                        style={{
                            fontSize: "1.05rem",
                            lineHeight: "1.65",
                            color: "#3a3a3a",
                            maxWidth: "900px",
                            margin: "0 auto 32px",
                        }}
                    >
                        Unser Ziel ist es, hochqualifiziertes medizinisches Personal zu finden, das perfekt zu Ihrem Team passt. Mit unserer professionellen Unterstützung begleiten wir Sie während des gesamten Einstellungsprozesses. Vertrauen Sie auf unsere Expertise. Kontaktieren Sie uns noch heute und finden Sie die passenden Lösungen für Ihren Personalbedarf.
                    </p>
                    <Row className="mt-4 g-4">
                        <Col md={4} xs={12} style={{ textAlign: "center" }}>
                            <div style={{ marginBottom: "12px" }}>
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="14" y="18" width="52" height="44" rx="4" stroke="#111D4B" strokeWidth="3" />
                                    <rect x="20" y="24" width="40" height="32" rx="2" stroke="#111D4B" strokeWidth="3" />
                                    <circle cx="40" cy="40" r="6" stroke="#111D4B" strokeWidth="3" />
                                    <path d="M30 54c2.5-4.5 6.5-7 10-7s7.5 2.5 10 7" stroke="#111D4B" strokeWidth="3" strokeLinecap="round" />
                                </svg>
                            </div>
                            <h4 style={{ color: "#8c1030", fontWeight: 600 }}>Großer Kandidatenpool</h4>
                            <p style={{ color: "#444", lineHeight: "1.5", marginBottom: 0 }}>
                                Netzwerk aus über 5000 Kontakten in unserer internen Datenbank.
                            </p>
                        </Col>
                        <Col md={4} xs={12} style={{ textAlign: "center" }}>
                            <div style={{ marginBottom: "12px" }}>
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="20" y="14" width="40" height="52" rx="6" stroke="#111D4B" strokeWidth="3" />
                                    <path d="M28 26h24" stroke="#111D4B" strokeWidth="3" strokeLinecap="round" />
                                    <path d="M28 34h24" stroke="#111D4B" strokeWidth="3" strokeLinecap="round" />
                                    <path d="M28 42h16" stroke="#111D4B" strokeWidth="3" strokeLinecap="round" />
                                    <rect x="44" y="40" width="8" height="8" rx="2" fill="#111D4B" />
                                    <path d="M32 54l6-8 6 6 10-12" stroke="#111D4B" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h4 style={{ color: "#8c1030", fontWeight: 600 }}>Passende Kandidaten</h4>
                            <p style={{ color: "#444", lineHeight: "1.5", marginBottom: 0 }}>
                                Wir stellen Ihnen innerhalb kurzer Zeit (2–4 Wochen) passende Kandidaten für Ihre Einrichtung vor.
                            </p>
                        </Col>
                        <Col md={4} xs={12} style={{ textAlign: "center" }}>
                            <div style={{ marginBottom: "12px" }}>
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24 50c0-7.5 5.5-12.5 16-12.5S56 42.5 56 50" stroke="#111D4B" strokeWidth="3" strokeLinecap="round" />
                                    <circle cx="32" cy="36" r="5" stroke="#111D4B" strokeWidth="3" />
                                    <circle cx="48" cy="36" r="5" stroke="#111D4B" strokeWidth="3" />
                                    <path d="M40 45.5c3.8 0 7.2 2.2 9.6 6.3" stroke="#111D4B" strokeWidth="3" strokeLinecap="round" />
                                    <rect x="18" y="26" width="44" height="30" rx="10" stroke="#111D4B" strokeWidth="3" />
                                    <path d="M16 34h-6M16 44h-6" stroke="#111D4B" strokeWidth="3" strokeLinecap="round" />
                                    <path d="M70 34h-6M70 44h-6" stroke="#111D4B" strokeWidth="3" strokeLinecap="round" />
                                    <path d="M24 24l4-6h24l4 6" stroke="#111D4B" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M30 18h20" stroke="#111D4B" strokeWidth="3" strokeLinecap="round" />
                                    <path d="M26 56c3.5 2.5 8.3 4 14 4s10.5-1.5 14-4" stroke="#111D4B" strokeWidth="3" strokeLinecap="round" />
                                </svg>
                            </div>
                            <h4 style={{ color: "#8c1030", fontWeight: 600 }}>Onboarding</h4>
                            <p style={{ color: "#444", lineHeight: "1.5", marginBottom: 0 }}>
                                Betreuung der Berufsanerkennung sowie Unterstützung bei der Integration.
                            </p>
                        </Col>
                    </Row>
                </div>
            </Container>
            <Container className="my-5">
                <div
                    style={{
                        backgroundColor: "#fff",
                        borderRadius: "18px",
                        boxShadow: "0 18px 45px rgba(0,0,0,0.08)",
                        padding: "24px",
                    }}
                >
                    <Row className="align-items-center g-4">
                        <Col lg={6} xs={12}>
                            <p style={{ color: activeColor, fontSize: "2.4rem", fontWeight: 700, marginBottom: "16px", lineHeight: 1.1 }}>
                                Unsere Dienstleistung
                            </p>
                            <div style={{ marginBottom: "20px" }}>
                                <div style={{ display: "flex", alignItems: "baseline", gap: "8px", marginBottom: "8px" }}>
                                    <span style={{ color: baseColor, fontSize: "2.2rem", fontWeight: 800 }}>01</span>
                                    <span style={{ color: activeColor, fontSize: "1.2rem", fontWeight: 700 }}>Suche nach Kandidaten</span>
                                </div>
                                <p style={{ color: "#4a4a4a", lineHeight: 1.6, marginBottom: 0 }}>
                                    Wir identifizieren innerhalb kurzer Zeit passende Kandidaten für Ihre offenen Positionen, die zur Unternehmenskultur passen. Sie sparen Zeit beim Sichten von Bewerbungen.
                                </p>
                            </div>
                            <div>
                                <div style={{ display: "flex", alignItems: "baseline", gap: "8px", marginBottom: "8px" }}>
                                    <span style={{ color: baseColor, fontSize: "2.2rem", fontWeight: 800 }}>02</span>
                                    <span style={{ color: activeColor, fontSize: "1.2rem", fontWeight: 700 }}>Übernahme Rekrutierungsprozess</span>
                                </div>
                                <p style={{ color: "#4a4a4a", lineHeight: 1.6, marginBottom: 0 }}>
                                    Unser Recruiting-Team arbeitet eng mit Ihnen zusammen, versteht Ihre Erwartungen und übernimmt Kommunikation, Auswahl und Begleitung der Kandidaten.
                                </p>
                            </div>
                        </Col>
                        <Col lg={6} xs={12}>
                            <div
                                style={{
                                    backgroundColor: "#f5f7fb",
                                    borderRadius: "18px",
                                    padding: "12px",
                                    boxShadow: "0 16px 40px rgba(0,0,0,0.08)",
                                }}
                            >
                                <Image src={serviceIllustration} alt="Dienstleistung Illustration" fluid style={{ borderRadius: "12px" }} />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
            <Container fluid className="my-5 px-0">
                <div style={{ position: "relative" }}>
                    <Image src={meetingPic} alt="Meeting" fluid style={{ width: "100%", height: "auto", display: "block" }} />
                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            background: "linear-gradient(180deg, rgba(0,0,0,0.45), rgba(0,0,0,0.45))",
                        }}
                    />
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "12%",
                            transform: "translateY(-50%)",
                            color: "#fff",
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                            textAlign: "left",
                            maxWidth: "420px",
                        }}
                    >
                        <h2 style={{ fontSize: "2.8rem", fontWeight: 300, margin: 0 }}>Kostenlose Anfrage</h2>
                        <p style={{ fontSize: "1.1rem", fontWeight: 300, margin: 0 }}>
                            Nehmen Sie Kontakt auf und erfahren Sie, wie wir Ihnen helfen können.
                        </p>
                        <div>
                            <Button
                                href="/Kontakt"
                                variant="outline-light"
                                size="lg"
                                style={{
                                    padding: "10px 22px",
                                    borderRadius: "999px",
                                    fontWeight: 600,
                                    fontSize: "1rem",
                                    backgroundColor: "rgba(255,255,255,0.08)",
                                    borderWidth: "2px",
                                }}
                            >
                                Kontakt
                            </Button>
                        </div>
                    </div>
                </div>
            </Container>
            <Container className="my-5">
                <div style={{ maxWidth: "1100px", margin: "0 auto", textAlign: "center" }}>
                    <div style={{ display: "inline-flex", alignItems: "baseline", gap: "10px", marginBottom: "10px" }}>
                        <span style={{ color: baseColor, fontSize: "2.4rem", fontWeight: 800 }}>03</span>
                        <h2 style={{ color: "#111D4B", fontWeight: 600, marginBottom: 0 }}>Vermittlungsprozess</h2>
                    </div>
                    <p style={{ color: "#4a4a4a", fontSize: "1.05rem", lineHeight: "1.6", marginBottom: "24px" }}>
                        Schritt für Schritt zu den passenden Fachkräften – transparent, strukturiert und zuverlässig.
                    </p>
                </div>
                <div className="dienst-timeline-container">
                    <div
                        className="dienst-timeline-vline"
                        style={{ background: baseColor }}
                    />
                    {timelineSteps.map((step, index) => {
                        const isLeft = index % 2 === 0;
                        const cardContent = (
                            <div
                                className="dienst-timeline-card"
                                style={{
                                    backgroundColor: "#fff",
                                    borderRadius: "18px",
                                    boxShadow: "0 14px 30px rgba(0,0,0,0.08)",
                                    padding: "20px",
                                    maxWidth: "500px",
                                    margin: isLeft ? "0 24px 0 auto" : "0 auto 0 24px",
                                }}
                            >
                                <h4 style={{ color: "#2d2d2d", fontWeight: 700, marginBottom: "10px" }}>{step.title}</h4>
                                <p style={{ color: "#4a4a4a", marginBottom: 0, lineHeight: "1.5" }}>{step.description}</p>
                            </div>
                        );
                        return (
                            <div
                                key={step.title}
                                className="dienst-timeline-step"
                                style={{ marginBottom: index === timelineSteps.length - 1 ? 0 : "40px" }}
                            >
                                {isLeft ? cardContent : <div className="dienst-timeline-spacer" />}
                                <div className="dienst-timeline-center">
                                    <div
                                        style={{
                                            width: "60px",
                                            height: "60px",
                                            borderRadius: "50%",
                                            backgroundColor: hoveredIndex === index ? activeColor : baseColor,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "#fff",
                                            fontWeight: 700,
                                            fontSize: "1.2rem",
                                            boxShadow: "0 8px 18px rgba(0,0,0,0.15)",
                                            position: "relative",
                                            zIndex: 2,
                                        }}
                                        onMouseEnter={() => setHoveredIndex(index)}
                                        onMouseLeave={() => setHoveredIndex(null)}
                                    >
                                        {String(index + 1)}
                                    </div>
                                    {index !== timelineSteps.length - 1 && (
                                        <div style={{ width: "4px", height: "100%", backgroundColor: baseColor, borderRadius: "2px" }} />
                                    )}
                                </div>
                                {!isLeft ? cardContent : <div className="dienst-timeline-spacer" />}
                            </div>
                        );
                    })}
                </div>
            </Container>
            <div id="referenzen">
                <Image
                    src={referenzenFooter}
                    alt="Referenzen Banner"
                    fluid
                    style={{ width: "100%", height: "auto", display: "block" }}
                />
            </div>
        </>
    ) 
}
export default Diensleistung;
